// packages/web/src/api/change-log/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { changeLogList } from "../generated/sdk.gen.ts";
import { changeLogKeys } from "./keys.ts";

export function changesOptions(
  userId: string,
  weekISO?: string,
  entityType?: "HoursEntry" | "TripDeclaration" | "LodgingDeclaration",
) {
  return queryOptions({
    queryKey: changeLogKeys.me(userId, weekISO, entityType),
    queryFn: async () => {
      const { data, error } = await changeLogList({
        query: {
          affected: "me",
          week: weekISO,
          entityType,
          limit: "100",
        },
      });
      if (error) throw error;
      if (!data) throw new Error("Change-log failed");
      return data.data;
    },
    staleTime: 30_000,
  });
}
